"use client";

import BrandsSection from "../../(home)/components/BrandsSection";

const BrandsWrapper = () => {
  return (
    <div className="mb-24 max-w-5xl mx-auto">
      <BrandsSection />
    </div>
  );
};

export default BrandsWrapper; 